export default "__VITE_ASSET__BrESnnD3__"